(ns practitest.frontend.components2.dashboard.charts.marks
  (:require [practitest.frontend.components2.dashboard.charts.marks-gen :as gen]
            [practitest.frontend.components2.dashboard.charts.marks-bar :as bar]
            [practitest.frontend.components2.dashboard.charts.markers :as markers]
            ["d3" :as d3]))

(defmulti render!
  (fn [_svg-g mark _spec] (:type mark)))

(defn- grouping-field [encode]
  (or (get-in encode [:color :field])
      (get-in encode [:detail :field])))

(defn- sorting-field [encode]
  (or (get-in encode [:order :field])
      (get-in encode [:x :field])))

(def AreaRows
  [:vector [:map-of :string [:or inst? number?]]])

(defn prepare-area-rows
  {:malli/schema [:=> [:cat
                       [:sequential inst?]
                       [:map-of inst? [:vector [:map
                                                [:date  inst?]
                                                [:group :string]
                                                [:value number?]]]]
                       :keyword]
                  AreaRows]}
  [categories by-category x-field]
  (mapv (fn [cat]
          (let [rows-for-cat (get by-category cat [])
                base-row     {(name x-field) cat}]
            (reduce (fn [obj {:keys [group value]}]
                      (assoc obj (str group) value))
                    base-row
                    rows-for-cat)))
        categories))

(defn- prepare-data [encode data]
  (let [grp-field (grouping-field encode)
        srt-field (sorting-field encode)]
    (-> data
        (cond->>
            (vector? data) (group-by grp-field))
        (update-vals #(vec (sort-by srt-field %))))))

(defmethod render! :line
  [svg _mark {:keys [data encode] :as ctx}]
  (let [svg-g       (.select svg "g.chart g.marks")
        color-scale (get-in encode [:color :d3-scale])
        line-gen    (gen/line ctx)
        series   (->> data
                      (prepare-data encode)
                      (mapv (fn [[k line-data]]
                              {:key    (some-> k name)
                               :color  (when color-scale (color-scale k))
                               :points line-data})))
        paths    (-> svg-g
                     (.selectAll "path.mark-line")
                     (.data (clj->js series) (fn [d] (aget d "key"))))]
    (-> (.enter paths)
        (.append "path")
        (.attr "class" (fn [d] (str "mark-line " (aget d "key"))))
        (.attr "fill" "none")
        (.attr "stroke-width" 2)
        (.merge paths)
        (.attr "stroke" (fn [d] (or (aget d "color") "#888")))
        (.attr "d" (fn [d] (line-gen (aget d "points")))))
    (-> (.exit paths)
        (.remove))))

(defmethod render! :bar
  [svg mark {:keys [encode] :as ctx}]
  (if (get-in encode [:y :stacked])
    (bar/render-stacked! svg mark ctx)
    (bar/render-bar! svg mark ctx)))

(defmethod render! :area
  [svg _mark {:keys [data encode width tooltip point tooltip-spec]}]
  (let [marks-g       (.select svg "g.chart g.marks")
        x-scale       (get-in encode [:x :d3-scale])
        y-scale       (get-in encode [:y :d3-scale])
        color-scale   (get-in encode [:color :d3-scale])
        x-type        (get-in encode [:x :type])
        x-field       (get-in encode [:x :field])
        categories    (or (get-in encode [:x :scale :domain])
                          (->> data (map x-field) (sort-by #(.getTime %)) (dedupe)))
        series-field  (get-in encode [:color :field])
        series-labels (->> data (map series-field) distinct)
        baseline-y    (y-scale 0)
        by-category   (group-by x-field data)
        row-data      (clj->js (prepare-area-rows categories by-category x-field))
        stack         (-> (.stack d3) (.keys (into-array (map str series-labels))))
        layers        (stack row-data)
        series-sel    (-> marks-g
                          (.selectAll "path.mark-area")
                          (.data layers (fn [^js layer] (.-key layer))))
        entered       (-> (.enter series-sel)
                          (.append "path")
                          (.attr "class" "mark-area"))
        x-mid         (fn [^js d] (x-scale (aget (.-data d) (name x-field))))
        area-gen      (gen/area x-mid y-scale)
        area-flat     (gen/area-flat x-mid baseline-y)]

    (-> (.exit series-sel)
        (.transition) (.duration 200)
        (.style "opacity" 0)
        (.remove))

    (-> entered
        (.attr "fill" (fn [^js layer] (color-scale (.-key layer))))
        (.attr "fill-opacity" 0.8)
        (.attr "d" (fn [^js layer] (area-flat layer))))

    (-> (.merge entered series-sel)
        (.attr "fill" (fn [^js layer] (color-scale (.-key layer))))
        (.attr "fill-opacity" 0.8)
        (.transition) (.duration 300) (.ease (.-easeCubicOut d3))
        (.attr "d" (fn [^js layer] (area-gen layer))))

    (when point
      (markers/render!
       {:marks-g      marks-g
        :x-scale      x-scale
        :x-type       x-type
        :x-format     (get-in encode [:x :axis :format])
        :y-fn         (fn [^js layer cat-idx]
                        (y-scale (aget (aget layer cat-idx) 1)))
        :color-fn     (fn [^js layer]
                        (color-scale (.-key layer)))
        :categories   categories
        :layers       layers
        :inner-width  width
        :baseline-y   baseline-y
        :tooltip      tooltip
        :tooltip-spec tooltip-spec}))))
